export default {
      id: "triangle-usage",
      viewBox: "0 0 6 4",
      url: __webpack_public_path__ + "svg/sprite.svg#triangle",
      toString: function () {
        return this.url;
      }
    }